import { required } from "vuelidate/lib/validators";
import {ModelObject} from "@/pages/Common/modelObject";
import {EARS_CROP, HAIR_TYPE, TAIL_CROP} from "@/pages/AppPages/Events/Clinical/initial";

export class Animal extends ModelObject {
    constructor(initObjectParams) {
        super(initObjectParams);
        // поля формы
        this.id = null;
        this.regNumber = null;
        this.shelterRegNumber = null;
        this.breed = null;
        this.chipId = null;
        this.labelId = null;
        this.avatarId = null;
        this.reviewDate = null;

        // объекты-модели для списков в форме
        this.breedObject = {};

        // атрибуты read-only. Хранятся как были получены - без переименования ключей
        // Для получения данных из них определяем в классе геттеры
        // this.avatarObject = null;
        this.descriptionObject = null;
        this.shelterObject = null;
        this.lastCatchingObject = null;
        this.lastInitialInspectionObject = null;
        this.lasVaccinationObject = null
        this.lastSurveyObject = null;
        this.lastKeepingObject = null;
        this.lastReturnToOwnerObject = null;
        this.lastReturnToHabitatObject = null;
        this.lastDeathObject = null;
        this.lastEuthanasiaObject = null;

        this.isArchived = false;
        this.archiveDate = null;
        this.currentPack = null;
        this.fullName = null;

        this.canKeep = false; // PETS-473

        this.applyInitObjectParams(initObjectParams);
    }

    static get modelName() {
        return 'Animal'
    }

    static get validations() {
        return {
            regNumber: { required },
            shelterRegNumber: { required },
            chipId: {  },
            labelId: {  },
            breed: { required },
            avatarId: {},
            reviewDate: {}
        }
    }

    static get validationFieldLabels() {
        return {
            regNumber: 'Рег. №',
            shelterRegNumber: 'Регистрационный номер приюта',
            chipId: 'Чип',
            labelId: 'Бирка',
            breed: 'Вид и порода',
            reviewDate: 'Дата проверки'
        }
    }

    static get mapping() {
        return {
            regNumber: 'reg_number',
            shelterRegNumber: 'shelter_reg_number',
            chipId: 'chip_id',
            labelId: 'label_id',
            avatarId: 'avatar',
            reviewDate: 'review_date'
        }
    }

    static get label() {
        return 'Животное'
    }

    label() {
        return 'Животное'
    }

    static get newLabel() {
        return 'Новое животное'
    }

    objectLabel() {
        const breedName = this.breedName ? this.breedName.toString().toLowerCase() : '';
        return `№${this.regNumber} ${this.speciesName}, ${breedName}`
    }

    get image() {
        return this.descriptionObject['image']
    }

    set image(image) {
        this.descriptionObject['image'] = image
    }

    get avatar() {
        return this.descriptionObject['thumbnail']
    }

    get breedName() {
        return this.descriptionObject['breed_name']
    }

    get species() {
        return this.descriptionObject['species']
    }

    get speciesName() {
        return this.descriptionObject['species_name']
    }

    get gender() {
        return this.descriptionObject['gender']
    }

    get genderName() {
        return this.descriptionObject['gender_name']
    }

    get isShelterInfoRestricted() {
        return !Boolean(this.shelterObject)
    }

    get alive() {
        return this.shelterObject && this.shelterObject['alive']
    }

    get isKept() {
        // PETS-473: это данные из shelterObject - он недоступен, если животное было ранее выпущено из другого приюта
        return this.shelterObject && this.shelterObject['alive'] && this.shelterObject['kept']
    }

    get lastKeepingData() {
        return this.lastKeepingObject
    }

    get keepingPlaceId() {
        if (this.lastKeepingData) {
            return this.lastKeepingData['executor_contract_object']['contractor_object']['id']
        }
        return null
    }

    get lastCatchingId() {
        if (this.lastCatchingObject) {
            return this.lastCatchingObject['id']
        }
    }

    get lastCatchingRequestId() {
        if (this.lastCatchingObject) {
            return this.lastCatchingObject['request_object']['id']
        }
    }

    get lastDisposalData() {
        if (this.alive) {
            if (this.lastReturnToOwnerObject) {
                return this.lastReturnToOwnerObject
            }
            if (this.lastReturnToHabitatObject) {
                return this.lastReturnToHabitatObject
            }
        } else {
            if (this.lastDeathObject) {
                return this.lastDeathObject
            }
            if (this.lastEuthanasiaObject) {
                return this.lastEuthanasiaObject
            }
        }
    }

    get hasLastDistinctiveData() {
        return Boolean(this.lastInitialInspectionObject && this.lastInitialInspectionObject['id'])
    }

    get lastDistinctiveData() {
        return this.lastInitialInspectionObject ? this.lastInitialInspectionObject['attributes'] : {};
    }

    get earCropText() {
        const earCrop = this.lastDistinctiveData['earCrop'];
        if (!earCrop) return null;
        return EARS_CROP[earCrop]
    }

    get tailCropText() {
        const tailCrop = this.lastDistinctiveData['tailCrop'];
        if (!tailCrop) return null;
        return TAIL_CROP[tailCrop]
    }

    get hairTypeText() {
        const hairType = this.lastDistinctiveData['hairType'];
        if (!hairType) return null;
        return HAIR_TYPE[hairType]
    }

    get reviewed() {
        if (this.descriptionObject.hasOwnProperty('is_reviewed')) {
            return this.descriptionObject['is_reviewed']
        }
        if (this.descriptionObject.hasOwnProperty('reviewed')) {
            return this.descriptionObject['reviewed']
        }
        return false
    }

    applyData(data) {
        if (data.hasOwnProperty('avatar')) {
            data['avatarId'] = data['avatar'];
        }
        super.applyData(data);
    }
}
